import { fromJS } from "immutable";
import {
    AddUpdateAllocationDimensionAttributeRequestAction,
    UpdateAllocationDimensionAttributeRequestAction,
} from "actions/allocation-dimension";
import { COLLECTIONS } from "constants/action-types";
import { ActionsObservable } from "redux-observable";
import { mixedSetOperation, MutableType } from "actions/mutate";
import { getAllocationDimensionById } from "reducers/selectors/collection";

export const updateAllocationDimensionAttribute = (
    action$: ActionsObservable<UpdateAllocationDimensionAttributeRequestAction>,
    store$
) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.ATTRIBUTES.UPDATE.REQUEST)
        .switchMap(({ payload, meta }) => {
            const { objectId } = meta;
            const { allocationDimensionAttribute } = payload;

            const actions = [];

            const updatedAttributes = fromJS({
                struct_value: {
                    keys: allocationDimensionAttribute,
                },
            });
            actions.push(
                mixedSetOperation(objectId, MutableType.Map, "field_map", "attributes", updatedAttributes, undefined, {
                    history: true,
                })
            );

            return actions;
        });

/**
 * Dispatches a sequence of add attribute and update dimension value requests.
 * @param action$
 * @param store$
 * @returns
 */
export const addAllocationDimensionAttributeThenUpdate = (
    action$: ActionsObservable<AddUpdateAllocationDimensionAttributeRequestAction>,
    store$
) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.ATTRIBUTES.ADD_UPDATE.REQUEST)
        .switchMap(({ payload, meta }) => {
            const { allocationDimensionAttributes, indexToItemMap } = payload;
            const { objectId } = meta;
            const state = store$.getState();
            const allocationDimension = getAllocationDimensionById(state, objectId);

            const actions = [];
            for (const [_key, value] of indexToItemMap) {
                const index = allocationDimension?.dimension_values.findIndex(
                    (currentItem) => currentItem.id === value.id
                );
                const mutatedItem = fromJS({
                    struct_value: value,
                });

                actions.push(
                    mixedSetOperation(objectId, MutableType.List, "dimension_values", index, mutatedItem, undefined, {
                        history: true,
                    })
                );
            }

            if (allocationDimensionAttributes) {
                const updatedAttributes = fromJS({
                    struct_value: {
                        keys: allocationDimensionAttributes,
                    },
                });
                actions.push(
                    mixedSetOperation(
                        objectId,
                        MutableType.Map,
                        "field_map",
                        "attributes",
                        updatedAttributes,
                        undefined,
                        { history: true }
                    )
                );
            }

            return actions;
        });
};
